import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginCredential, moduleDropdown, printerPopupSearchPageCredential } from '../ReduxState';
import { fncLoginApi } from '../Utility/ApiCall.js';
import { checkinModule, fncCheckIfTokenIsExpired } from '../Utility/CommonFun';
import { ToastContainer, toast } from 'react-toastify';
import { localeData } from 'moment';
import {useHistory} from 'react-router-dom';

function Login(props) {
    const history = useHistory();
    // REACT HOOKS STARTS FROM HERE -------------------------
    const [st_username, setUserName] = useState('');
    const [st_password, setPassword] = useState('');
    const [st_ErrorUsername, setErrorUserName] = useState('');
    const [st_ErrorPassword, setErrorPassword] = useState('');
    const UserName = useSelector(state => state.login.UserName);
    const Role = useSelector(state => state.login.Role);
    const IsLogin = useSelector(state => state.login.IsLogin);
    const dispatch = useDispatch()
    const inputForUsername = useRef(null);
    // REACT HOOKS ENDS HERE----------------------------------

    //---------------------- TOAST ERROR MESSAGE CODE STARTS HERE ----------------------------
    const notify = (e) =>
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    //---------------------- TOAST ERROR MESSAGE CODE ENDS HERE ----------------------------


    //---------------------- USEEFFECT REACT HOOK STARTS FROM HERE -------------------------
    // DESC : The hook called once after the page load.
    // Functinality completed : Enter button click is handled here to submit the login form.
    useEffect(() => {
        var input = document.getElementById("USERNAME");
        input.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("btnLogin").click();
            }
        });
        var input = document.getElementById("PASSWORD");
        input.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("btnLogin").click();
            }
        });
    }, [])

    /** focus on element on every rennder of component */
    useEffect(() => {
        // `current` points to the mounted text input element
        inputForUsername.current.focus();
    },[]);
    //---------------------- USEEFFECT REACT HOOK ENDS FROM HERE -----------------------------------------------

    //---------------------- ValidationCheck function STARTS FROM HERE -----------------------------------------
    // DESC : The function is called to check the validaton.
    // Functinality completed : The function will check the username and password validation.
    function ValidationCheck() {
        if (st_username == "") {
            setErrorUserName('Please enter UserName');
            return false;
        }
        if (st_password == "") {
            setErrorPassword('Please enter Password');
            return false;
        }
        return true;
    }
    //---------------------- ValidationCheck function ENDS HERE ------------------------------------------------


    //---------------------- fncLoginSubmit function STARTS FROM HERE ----------------------------------------------
    // DESC : The function is used to send data of login form to server using axios.
    // Functinality completed : The function is called to submit the login form to server.
    function fncLoginSubmit(e) {
        var valCheck = ValidationCheck();
        if (valCheck) {
            // debugger
            fncLoginApi(st_username, st_password)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(returnVal.statusText);
                    }
                    else if (returnVal.status == "500" && returnVal.data.isError === undefined) {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify('Currently we are facing some issues, please try again later.');
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (returnVal.data.isError == false || returnVal.data.isError == undefined) {
                            localStorage.setItem("LoginToken", returnVal.data.token);
                            history.push("/Search");
                            dispatch(loginCredential(
                                {
                                    type: "",
                                    UserName: returnVal.data.username,
                                    Password: "",
                                    Role: returnVal.data.role,
                                    CheckInRights: returnVal.data.rights.filter(right => right.mode === 'Check-In'),
                                    BoardingRights: returnVal.data.rights.filter(right => right.mode === 'Boarding'),
                                    Token: returnVal.data.token,
                                    Theme: returnVal.data.theme,
                                    IsLogin: true,
                                    Location: returnVal.data.location,
                                    RoleCode: returnVal.data.roleCode,
                                    bp: returnVal.data.bp,
                                    bt: returnVal.data.bt, 
                                    // isFlyBigRequired: returnVal.data.isFlyBigRequired
                                }
                            ));
                            dispatch(moduleDropdown(
                                {
                                  type:"",
                                  module: checkinModule
                                }
                            ));
                            dispatch(printerPopupSearchPageCredential(
                                {
                                    type: "",
                                    isPrinterPopupSearchPageOpen: true,
                                
                                }
                            ));
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                                    notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                })
                .catch(err => console.log("Axios err: ", err))
        }
    }
    //---------------------- fncLoginSubmit function ENDS HERE -------------------------------------------------------

    //---------------------- fncOnChange function STARTS FROM HERE ---------------------------------------------------
    // DESC : The function checks validation while entering the text inside the username and password textbox.
    // Functinality completed : The function is called to handle input text typed inside username and password textbox.
    function fncOnChange(e) {
        if (e.target.id == "USERNAME") {
            var alphaNumeric = /^[0-9a-zA-Z]+$/;
            if (e.target.value != "") {
                if (e.target.value.match(alphaNumeric)) {
                    setUserName(e.target.value);
                }
            }
            else {
                setUserName(e.target.value);
                setErrorUserName("");
            }   
        }
        else if (e.target.id == "PASSWORD") {
            setPassword(e.target.value);
            if (e.target.value != "") {
                setErrorPassword("");
            }
        }
    }
    //---------------------- fncOnChange function STARTS FROM HERE --------------------------------------------

    return (
        <div class="hero-area-body fullHeight">
            <div class="container fullHeight">
                <div class="row fullHeight align-content-center">
                    <div class="col-12 login-box rounded">
                        <div class="row">
                            <div class="col-12 col-lg-7 py-3 login-banner">
                                <div class="login-banner-caption">
                                    <span class="welcome-text d-block">Welcome To</span>
                                    <h1 class="mt-0 pb-3 mb-2">Airport Checkin</h1>
                                    <p>Login to Access Dashboard</p>
                                </div>
                                <img src="images/bg-01.jpg" class="rounded" />
                            </div>

                            <div class="col-12 col-lg-5">
                                <div class="col-12 col-md-10 offset-md-1 pl-3 pl-md-0 mb-5">
                                    <div class="theme-login">
                                        <div tabIndex="-1" class="login-header text-center my-5">
                                            <img src="images/spicejet-logo.png" alt="Spicejet" />
                                        </div>
                                        <div class="row">

                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form-group sp-formField mb-3">
                                                            <input ref={inputForUsername} tabIndex="0" type="text" class="form-control not-empty" id="USERNAME" value={st_username} onChange={e => fncOnChange(e)} autocomplete="Enter your ID" name="Username" />
                                                            <span class="label">Username<span class="color-red">*</span></span>
                                                            <span className="clsError" >{st_ErrorUsername}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="form-group sp-formField mt-4">
                                                            <input tabIndex="0" type="password" class="form-control not-empty" id="PASSWORD" value={st_password} onChange={e => fncOnChange(e)} autocomplete="new-password" name="Password" />
                                                            <span class="label">Password<span class="color-red">*</span></span>
                                                            <span className="clsError">{st_ErrorPassword}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 mt-3">
                                                        <input tabIndex="0" type="submit" id="btnLogin" onClick={e => fncLoginSubmit(e)} class="btn btn-red text-uppercase btn-loader sp-min-w-150" value="Sign In" />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Login;